<template>
    <b-card no-body>
        <b-card-header class="border-0">
            <h3 class="mb-0">{{ $t('folios') }}</h3>
        </b-card-header>

        <b-row class="ml-3 justify-content-start align-items-start">
            <b-col v-if="rol === 'admin'" md="6">
                <b-form-group label-for="orden" class="mb-0 d-flex">
                    <template v-slot:label>
                        {{ $t('ordenar_por') }}:
                    </template>
                    <div>
                        <b-form-checkbox v-model="filter.OrderNuevos" :value="true" :unchecked-value="null" class="chek">
                            {{ $t('Recientes') }}
                        </b-form-checkbox>
                        <b-form-checkbox v-model="filter.OrderNuevos" :value="false" :unchecked-value="null" class="chek">
                            {{ $t('Antiguos') }}
                        </b-form-checkbox>
                    </div>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row class="ml-3 justify-content-center align-items-center">
            <b-col v-if="rol === 'admin'" md="auto" class="text-center">
                <b-form-group style="">
                    <b-button type="submit" @click="getAllFiltered()" variant="primary" style="margin-top: 0px;">
                        {{ $t('buscar') }}
                    </b-button>
                </b-form-group>
            </b-col>
        </b-row>

        <el-table class="table-responsive table" header-row-class-name="thead-light" :data="folios">
            <el-table-column :label="$t('folio')" prop="budget" min-width="50px">
                <template v-slot="{ row }">
                    <router-link :to="{ path: '/ingresos', query: { folio: row.folioPDI } }" class="status"
                        style="cursor: pointer; color: blue; text-decoration: underline;">
                        {{ row.folioPDI }}
                    </router-link>
                </template>
            </el-table-column>

            <el-table-column :label="$t('fecha_creacion')" min-width="50px" prop="empresa">
                <template v-slot="{ row }">
                    <span class="empresa">{{ row.fecha }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('hojas_disponibles')" min-width="50px" prop="direccion">
                <template v-slot="{ row }">
                    <span class="direccion">{{ row.hojasDisponibles }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('accion')" min-width="20px" prop="action">
                <template v-slot="{ row }">
                    <b-row>
                        <b-col>
                            <a @click="deleteRow(row.id)" variant="primary" class="btn-create-new">
                                <i class="fas fa-trash" style="color: red; cursor: pointer;"></i>
                            </a>
                        </b-col>
                        <b-col>
                            <a @click="exportMetales(row.folioPDI)" class="btn-create-new">
                                <i class="fa fa-file-alt" style="color: green; cursor: pointer;"></i>
                            </a>
                        </b-col>
                    </b-row>
                </template>
            </el-table-column>
        </el-table>

        <!-- <b-card-footer class="py-4 d-flex justify-content-end">
            <base-pagination v-model="currentPage" :per-page="10" :total="50"></base-pagination>
        </b-card-footer> -->
    </b-card>
</template>
<script>
import folioService from '@/api/folioService';
import materialService from '@/api/materialService';
import { Table, TableColumn } from 'element-ui'
import utilsService from '@/api/utilsService';

export default {
    name: 'folio-table',
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        rol() {
            return utilsService.getRol();
        }
    },
    data() {
        return {
            folios: [],
            currentPage: 1,
            filter: {
                OrderNuevos: true
            },
        };
    },
    async beforeMount() {
        try {
            this.folios = await folioService.getAll();
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    },
    methods: {
        async getAllFiltered() {
            const response = await folioService.getAllFiltered(this.filter);
            this.folios = response;
        },
        deleteRow(id) {
            Swal.fire({
                title: this.$t('estas_seguro'),
                html: `<h4><i><span style="color: red;">*</span> Al Eliminar el Folio se desvincularan todos las actas e ingresos asociados</i></h4>`,
                text: this.$t('confirma_eliminar'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: this.$t('si_eliminar'),
                cancelButtonText: this.$t('cancelar')
            }).then(async (result) => {
                if (result.isConfirmed) {

                    Swal.fire({
                        html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">Eliminando...</h3>
                        </div>
                    </div>`,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    });

                    const response = await folioService.deleteBy(id);
                    if (!response) {
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: this.$t('error')
                        });
                        return;
                    }
                    this.folios = await folioService.getAll();

                    Swal.fire({
                        text: this.$t('eliminado_correctamente'),
                        icon: "success",
                        showConfirmButton: false,
                        timer: 2000,
                        background: '#f8f9fa',
                        customClass: {
                            title: 'swal-title',
                            icon: 'swal-icon',
                        },
                    });
                }
            });

        },
        async exportMetales(folio) {
            try {
                Swal.fire({
                    html: `
                <div style="display: flex; align-items: center; justify-content: center;"> 
                  <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                  <div>
                    <h3 style="color: #006393;">`+ this.$t('generando_reporte') + `...</h3>
                  </div>
                </div>`,
                    showConfirmButton: false,
                    allowOutsideClick: false
                });
                await materialService.getReporteMetales(folio);
                Swal.close();

            } catch {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: this.$t("error_exportar")
                });
                return;
            }
        },
    }
}
</script>
